module.exports = __webpack_public_path__ + "img/active-layer3.f80933c6.png";